module.exports = __webpack_public_path__ + "img/crizal-sapphire.69dc0468.svg";